import { useEffect, useState } from 'react'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import { useSelector } from 'react-redux'
import { selectCurrentContractActive } from '../SubscriptionForm/SubscriptionFormSelectors'
import { useTranslation } from 'react-i18next'

const useSaleFormObserver = (type, country, id) => {
  const { t } = useTranslation()
  const [validations, setValidations] = useState(null)
  const { addErrorToContract } = useFormStatus()
  const contract = useSelector(selectCurrentContractActive)
  const upperCaseCountry = country.toUpperCase()
  const firstUpperCaseType = type.charAt(0).toUpperCase() + type.slice(1)
  const calculateMissingFields = async () => {
    const { default: validations } = await import(
      `./${firstUpperCaseType}/validation/${upperCaseCountry}/validation.js`
    )
    if (validations && Object.keys(validations).length > 0) {
      setValidations(validations)
      const countriesUsingV1Rule = ['FR', 'NL']
      Object.keys(validations).forEach(validationField => {
        const rule = validations[validationField]
        const isValid = countriesUsingV1Rule.includes(upperCaseCountry)
          ? rule(contract, true)
          : rule.validate(contract, true)
        if (!isValid) {
          addErrorToContract(id, {
            [validationField]:
              t(`subscriptionForm:validation_errors_v2.${validationField}`) ??
              `Field ${validationField} is missing in validation list translations`,
          })
        }
      })
    }
  }

  useEffect(() => {
    calculateMissingFields()
  }, [])

  return { validations }
}

export default useSaleFormObserver
